import React from 'react';
import { TranslatedContent } from 'libs/end-to-end/src/translation-content';
import { useGetColumnDisplayName } from 'apps/sigma2-ui/src/explore-section/hooks/useGetColumnDisplayName';
import { convertTranslatedContentToReactNode } from 'apps/sigma2-ui/src/lib/hooks/useTranslation';

interface PieChartPlaceholderProps {
  metricColumn: string;
  isLastInRow: boolean;
  message: TranslatedContent;
}

/**
 * Placeholder that mimics a Nivo donut pie chart when the chart cannot be rendered
 * (e.g. metric requires group-by breakdown).
 */
export const PieChartPlaceholder = (props: PieChartPlaceholderProps) => {
  const { metricColumn, isLastInRow, message } = props;

  const { getColumnDisplayName } = useGetColumnDisplayName();

  return (
    <div
      key={metricColumn}
      className={`bg-white relative ${!isLastInRow ? 'border-r border-[#D9D9D9]' : ''}`}
    >
      <h3 className="text-sm font-medium text-gray-700 mb-3 text-center">
        {getColumnDisplayName(metricColumn)}
      </h3>
      <div className={`w-full`}>
        <div className="w-full h-full flex flex-col items-center justify-center gap-3">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="266"
            height="180"
            role="img"
          >
            <g transform="translate(10,10)">
              <g transform="translate(123,70)">
                <path
                  d="M1.316,-66.861A3,3,0,0,1,4.509,-69.855A70,70,0,0,1,67.117,-19.881A3,3,0,0,1,64.906,-16.104L29.643,-8.088A3,3,0,0,1,26.174,-9.947A28,28,0,0,0,3.898,-27.727A3,3,0,0,1,1.316,-30.698Z"
                  opacity="1"
                  fill="#94a3b8"
                  stroke="rgb(84, 60, 178)"
                  strokeWidth="0"
                ></path>
                <path
                  d="M65.489,-13.537A3,3,0,0,1,69.116,-11.087A70,70,0,1,1,-6.944,-69.655A3,3,0,0,1,-3.648,-66.774L-2.386,-30.633A3,3,0,0,1,-4.863,-27.574A28,28,0,1,0,27.902,-2.345A3,3,0,0,1,30.226,-5.522Z"
                  opacity="1"
                  fill="#d1d5db"
                  stroke="rgb(179, 82, 60)"
                  strokeWidth="0"
                ></path>
              </g>
            </g>

            <text
              transform="translate(20,170) rotate(0)"
              style={{
                fontFamily: 'Karla, sans-serif',
                fontSize: '13px',
                fill: 'rgb(51, 51, 51)',
              }}
            >
              {convertTranslatedContentToReactNode(message)}
            </text>
          </svg>
        </div>
      </div>
    </div>
  );
};
